import { FC, useContext } from 'react'
import { WishlistShareBarContainer } from './styles'
import WishlistSection from '../../common/wishlist-section'
import { ThemeContext } from 'styled-components'
import ShareButton from '../share-button'

type WishlistShareBarProps = {
    listingId: string
}

const WishlistShareBar: FC<WishlistShareBarProps> = ({ listingId }) => {
    const theme = useContext(ThemeContext)
    if (!theme) return null
    return (
        <WishlistShareBarContainer>
            <WishlistSection
                width={theme.layout.xxSmall}
                height={theme.layout.xxSmall}
                listingId={listingId}
                containerHeight="2.5rem"
                containerWidth="2.5rem"
                containerPadding="0"
                containerBorderRadius="1.6875rem"
                containerMargin="0"
                containerborderColor={theme.colors.tfwBlack10}
                showBoxShadow={false}
            />
            <ShareButton
                width={theme.layout.medium}
                height={theme.layout.xxSmall}
                listingId={listingId}
                containerHeight="2.5rem"
                containerWidth="2.5rem"
                containerPadding="0"
                containerBorderRadius="1.6875rem"
                containerMargin="0"
                containerborderColor={theme.colors.tfwBlack10}
            />
        </WishlistShareBarContainer>
    )
}

export default WishlistShareBar
